var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// (webpack)/~/isarray/index.js
// module id = 273
// module chunks = 128